export default __webpack_public_path__ + "static/for-you-icons-784f993871ce306ae2c5e1f39d25b9ce.svg";